/*
 * Copyright (c) 2026. Pacesetter
 * All Rights Reserved
 */

import * as types from './types';

const initialState = {
  failedTransactionReports: [],
  failedTransactionReportsLoading: false,
  failedTransactionReportsError: null,
  failedTransactionReportsDownloading: false,
  failedTransactionReportsDownloadError: null,
  failedTransactionReportsDownloadResponse: [],
  manualTriggerLoading: false,
  manualTriggerError: null,
  manualTriggerSuccess: null,
  failReportConfigurationData: null,
  failReportConfigurationDataLoading: false,
  failReportConfigurationDataError: null,
  updateFailReportSentConfigurationLoading: false,
  updateFailReportSentConfigurationError: null,
  updateFailReportSentConfigurationResponse: null,
};

const accountingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ACCOUNTING_REPORTS_REQUEST:
      return {
        ...state,
        failedTransactionReportsLoading: true,
        failedTransactionReportsError: null,
      };
    case types.FETCH_ACCOUNTING_REPORTS_SUCCESS:
      return {
        ...state,
        failedTransactionReportsLoading: false,
        failedTransactionReports: action.data,
      };
    case types.FETCH_ACCOUNTING_REPORTS_FAILURE:
      return {
        ...state,
        failedTransactionReportsLoading: false,
        failedTransactionReportsError: action.error,
      };
    case types.DOWNLOAD_ACCOUNTING_REPORT_REQUEST:
      return {
        ...state,
        failedTransactionReportsDownloading: true,
        failedTransactionReportsDownloadError: null,
        failedTransactionReportsDownloadResponse: null,
      };
    case types.DOWNLOAD_ACCOUNTING_REPORT_SUCCESS:
      return {
        ...state,
        failedTransactionReportsDownloading: false,
        failedTransactionReportsDownloadResponse: action.data,
      };
    case types.DOWNLOAD_ACCOUNTING_REPORT_FAILURE:
      return {
        ...state,
        failedTransactionReportsDownloading: false,
        failedTransactionReportsDownloadError: action.error,
      };
    case types.MANUAL_TRIGGER_ACCOUNTING_REQUEST:
      return {
        ...state,
        manualTriggerLoading: true,
        manualTriggerError: null,
        manualTriggerSuccess: null,
      };
    case types.MANUAL_TRIGGER_ACCOUNTING_SUCCESS:
      return {
        ...state,
        manualTriggerLoading: false,
        manualTriggerSuccess: action.data,
      };
    case types.MANUAL_TRIGGER_ACCOUNTING_FAILURE:
      return {
        ...state,
        manualTriggerLoading: false,
        manualTriggerError: action.error,
      };
    case types.MANUAL_TRIGGER_ACCOUNTING_CLEAR:
      return {
        ...state,
        manualTriggerError: null,
      };
    case types.FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST:
      return {
        ...state,
        failReportConfigurationDataLoading: true,
        failReportConfigurationDataError: null,
      };
    case types.FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS:
      return {
        ...state,
        failReportConfigurationDataLoading: false,
        failReportConfigurationData: action.data,
      };
    case types.FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE:
      return {
        ...state,
        failReportConfigurationDataLoading: false,
        failReportConfigurationDataError: action.error,
      };
    case types.UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST:
      return {
        ...state,
        updateFailReportSentConfigurationLoading: true,
        updateFailReportSentConfigurationError: null,
        updateFailReportSentConfigurationResponse: null,
      };
    case types.UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS:
      return {
        ...state,
        updateFailReportSentConfigurationLoading: false,
        updateFailReportSentConfigurationResponse: action.data,
      };
    case types.UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE:
      return {
        ...state,
        updateFailReportSentConfigurationLoading: false,
        updateFailReportSentConfigurationError: action.error,
      };
    default:
      return state;
  }
};

export default accountingReducer;
